import React from 'react';
import { Button } from '@mui/material';

const MarketingBanner = ({
	imgSrc,
	title,
	subtitle,
	subtitlecontact,
	imgWidth = '84px',
	imgMarginLeft = '0px',
	buttonLabel,
	onButtonClick,
}) => {
	const isMobile = window.innerWidth < 480;
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				height: 'auto',
				padding: isMobile ? '24px' : 'auto',
				borderRadius: '12px',
				background: 'linear-gradient(90deg, #0b1fcb 0%, #9747ff 100%)',
				color: '#fff',
				marginTop: '12px',
			}}>
			{!isMobile && (
				<img
					src={imgSrc}
					alt='MarketingBannerImage'
					style={{
						width: imgWidth,
						height: 'auto',
						objectFit: 'contain',
						marginLeft: imgMarginLeft,
						marginRight: '16px',
						alignSelf: 'flex-end',
					}}
				/>
			)}
			<div style={{ flexGrow: 1, padding: '12px 0px' }}>
				<div style={{ fontSize: '16px', fontWeight: 700, marginBottom: '4px' }}>
					{title}
				</div>
				<div style={{ fontSize: '14px' }}>{subtitle}</div>
				<div style={{ fontSize: '14px', marginTop: '4px' }}>
					{subtitlecontact}
				</div>
			</div>
			{buttonLabel && onButtonClick && (
				<Button
					variant='contained'
					onClick={onButtonClick}
					sx={{
						fontFamily: 'Satoshi, sans-serif',
						backgroundColor: '#ffffff',
						color: '#1c32f3',
						fontWeight: 700,
						fontSize: '14px',
						textTransform: 'none',
						padding: '12px',
						borderRadius: '8px',
						boxShadow: 'none',
						marginRight: isMobile ? '0px' : '20px',
						marginLeft: isMobile ? '0px' : '10px',
						marginTop: isMobile ? '16px' : '0px',
						minWidth: '140px',
						width: isMobile ? '100%' : 'auto',
						'&:hover': {
							backgroundColor: '#e8eafe',
							boxShadow: 'none',
						},
					}}>
					{buttonLabel}
				</Button>
			)}
		</div>
	);
};

export default MarketingBanner;
